export default __webpack_public_path__ + "static/media/introduction_en.a70c024f.png";